import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAppointments,
  createAppointment,
  updateAppointment,
  deleteAppointment,
  fetchPatients,
  fetchDoctors,
} from "./calendaryThunks.js";

const initialState = {
  appointments: [],
  patients: [],
  doctors: [],
  loading: false,
  error: null,
};

const calendarySlice = createSlice({
  name: "calendary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET Appointments
      .addCase(fetchAppointments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.appointments = Array.isArray(payload)
          ? payload
          : payload?.results || [];
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al obtener citas";
      })

      // POST Appointment
      .addCase(createAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAppointment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) state.appointments.push(action.payload);
      })
      .addCase(createAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al crear cita";
      })

      // UPDATE Appointment
      .addCase(updateAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAppointment.fulfilled, (state, action) => {
        state.loading = false;
        const i = state.appointments.findIndex(
          (appointment) => appointment.id === action.payload.id
        );
        if (i > -1) state.appointments[i] = action.payload;
      })
      .addCase(updateAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al actualizar cita";
      })

      // DELETE Appointment
      .addCase(deleteAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAppointment.fulfilled, (state, action) => {
        state.loading = false;
        state.appointments = state.appointments.filter(
          (appointment) => appointment.id !== action.payload
        );
      })
      .addCase(deleteAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al eliminar cita";
      })

      // GET Patients
      .addCase(fetchPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.patients = Array.isArray(payload)
          ? payload
          : payload?.results || [];
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al obtener pacientes";
      })

      // GET Doctors
      .addCase(fetchDoctors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload;
        state.doctors = Array.isArray(payload)
          ? payload
          : payload?.results || [];
      })
      .addCase(fetchDoctors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error al obtener doctores";
      });
  },
});

export default calendarySlice.reducer;